<template>
    <div class="page-content" style="margin: 0px; width: 100%">
        <v-container fluid v-if="is_self_route">
          <EventsList></EventsList>
        </v-container>
        <router-view v-else></router-view>
    </div>
</template>

<script>
import {getInstMenu, getInstNameByRouterName} from "@/helper/instances";
import names from "@/modules/recording/routers/names";
import {isAuthenticated} from "@/helper";
import EventsList from "@/modules/recording/page/eventAdmin/EventsList";

export default {
        name: "AdminMenu",
        components: {EventsList},
        data: function () {
            return {
                names: names
            }
        },
        computed: {
            is_self_route: function () {
                return this.$route.name === names.ADMINEVENTS._BASE
            },
        },
        created() {
            this.$store.commit('leftmenu/selectInstance', getInstNameByRouterName(names.ADMINEVENTS._BASE));
            this.$store.commit('leftmenu/replaceItems', this.getLeftMenu());
            if (isAuthenticated() || this.$route.name === names.ADMIN._BASE) {
                this.$store.commit('leftmenu/replaceInstances', getInstMenu());
                this.$store.commit('leftmenu/enableLeftMenu');
                // this.$store.commit('leftmenu/hide');
            }
        },
        beforeRouteUpdate(to, from, next) {
            this.$store.commit('leftmenu/selectInstance', getInstNameByRouterName(names.ADMINEVENTS._BASE));
            this.$store.commit('leftmenu/replaceItems', this.getLeftMenu());
            next()
        },
        methods: {
            getLeftMenu() {
                let menu = []
                menu.push({title: 'Главная', icon: 'view_quilt', router: names.ADMINEVENTS._BASE, name: names.ADMINEVENTS._BASE,included:true})
                return menu
            }
        },
    }
</script>

<style scoped>

    #footer-pay {
        display: none !important;
    }

    .adminCart {
        height: 200px;
        text-align: center;
        line-height: 200px;
        font-size: 28px;
    }
</style>
